module.exports = __webpack_public_path__ + "static/media/videoEditor-1.fd20c0b8.png";